<template>
  <!-- 服务商 -->
  <div class="serviceProvider">
    <div class="service">资源匹配</div>
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane :label="item.title" :name="(index * 1 + 1).toString()" v-for="(item, index) in serviceTypeList"
        :key="index">
        <div class="service-wrap">
          <div class="empty" v-if="serviceList.length == 0">暂无数据</div>
          <div class="service-item" v-for="(content, index) in serviceList" :key="index">
            <div class="item-avater" :style="{ backgroundImage: `url(${content['pic']})` }"></div>
            <div class="item-right">
              <div class="title" @click="onClickDetail(content['uuid'])">{{ content["title"] }}</div>
              <div class="description">{{ content["description"] }}</div>
              <div class="ability-wrap">
                <div class="ability" v-for="(item, i) in content['capabilityList']" :key="i" v-if="i < 3">
                    <span  class="abilityText">{{ item.title }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
     <div class="more-btn" @click="onClickProviderMore">更多服务商</div>
  </div>
</template>

<script>
import { getServiceTypeList, getServiceList } from "../../utils/interface"
export default {
  name: "",
  components: {},
  props: {},
  data() {
    return {
      activeName: "1",
      serviceTypeList: [{ title: "智能制造集成" }, { title: "软件开发与设计" }], // 服务商分类
      serviceList: [
        {
          title: "宁夏菲麦森工业软件技术有限公司",
          pic:
            "https://zengcai.obs.cn-north-4.myhuaweicloud.com/2023-10-17%2F599341fd628f407199348a249a17be02.jpeg",
          description:
            "宁夏菲麦森工业软件技术有限公司宁夏菲麦森工业软件技术有限公司宁夏菲麦森工业软件技术有限公司宁夏菲麦森工业软件技术有限公司", // 描述
          linkMethod: "李先生 13856489654", // 联系方式
          caseList: [
            { title: "专家服务案例" },
            { title: "装备制造行业智能工厂数字化系统间集成" },
          ], // 典型案例列表
          capabilityList: [
            { title: "方案规划" },
            { title: "精益管理咨询" },
            { title: "数字化车间设计" },
          ], // 能力列表
        },
      ], // 服务商列表
    }
  },
  watch: {},
  computed: {},
  created() { },
  mounted() {
    this.getServiceTypeList() // 获取服务商分类列表
  },
  methods: {
    // 获取服务商分类列表
    getServiceTypeList() {
      getServiceTypeList().then((res) => {
        if (res && res.length > 0) {
          this.serviceTypeList = res
          this.getServiceList(res[0].uuid) // 默认展示第一类服务商的信息
        } else {
          this.serviceTypeList = []
        }
      })
    },
    // 获取服务商列表
    getServiceList(uuid) {
      getServiceList({
        status: 1,
        rec: 1,
        programUuid: uuid,
      }).then((res) => {
        if (res && res.length > 0) {
          this.serviceList = res
        } else {
          this.serviceList = []
        }
      })
    },
    // 众多优质服务商-查看更多
    onClickProviderMore() {
      let route = this.$router.resolve({
        path: "/providerList"
      });
      window.open(route.href, "_blank");
    },
    // 点击进入服务商详情
    onClickDetail(uuid) {
      let routeData = this.$router.resolve({
        path: "/providerDetail",
        query: {
          uuid: uuid,
          type: "provider",
          titleName: "直播列表",
          titleForm: "providerDetail",
        },
      })
      window.open(routeData.href, "_blank")
    },
    // 点击进入案例详情页
    goCaseDetail(uuid) {
      let routeData = this.$router.resolve({
        path: "/caseDetail",
        query: {
          uuid: uuid,
        },
      })
      window.open(routeData.href, "_blank")
    },
    handleClick(tab, event) {
      // console.log(tab.index)
      let index = tab.index
      this.getServiceList(this.serviceTypeList[index].uuid)
    },
  },
}
</script>
<style lang="less" scoped>
.service-wrap {
  margin: 10px auto 0;
  height: 440px;
  width: 1300px;
  display: flex;
  flex-wrap: wrap;
  .service-item {
    margin-right: 35px;
    margin-bottom: 22px;
    display: flex;
    width: 410px;
    height: 198px;
    padding: 30px 18px;
    border-radius: 8px;
    background: #F3F7FF;
    box-sizing: border-box;
    font-size: 18px;
    font-weight: 350;
    &:nth-child(3n) {
      margin-right: 0;
    }
  }
  .item-avater {
    margin-right: 18px;
    flex-shrink: 0;
    width: 60px;
    height: 60px;
    border-radius: 8px;
    background-size: cover;
    background-repeat: no-repeat;
  }
  .item-right {
    width: calc(100% - 78px);
    .title {
      margin-bottom: 10px;
      width: 100%;
      font-size: 24px;
      font-weight: bold;
      line-height: 1;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      cursor: pointer;
    }
    .description {
      width: 284px;
      height: 52px;
      margin-bottom: 18px;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .ability-wrap {
      display: flex;
      flex-wrap: wrap;
    }
    .ability {
      margin-right: 8px;
      margin-bottom: 8px;
      width: 77px;
      height: 31px;
      border-radius: 4px;
      opacity: 1;
      background: #DDE9FB;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 14px;
      font-weight: 350;
      color: #2D50A1;
      white-space: nowrap; /* 禁止文本换行 */
      overflow: hidden; /* 隐藏超出范围的内容 */
      text-overflow: ellipsis; /* 使用省略号 */
    }
  }
}
.more-btn {
  margin: 0 auto;
  width: 200px;
  height: 50px;
  border-radius: 4px;
  opacity: 1;
  background: #FFFFFF;
  box-sizing: border-box;
  border: 1px solid #2D50A1;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #2D50A1;
  font-size: 16px;
  font-weight: normal;
  cursor: pointer;
}
.serviceProvider {
  margin: 30px auto 28px;
  background-color: #fff;

  /deep/ .el-carousel__arrow {
    // background-color: rgba(31, 45, 61, .11);
    box-shadow: 0 0 3px #999999;
  }

  .curp {
    &:hover {
      cursor: pointer;
      color: #2d50a1;
    }
  }

  .over-num-lines {
    word-break: break-all;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    overflow: hidden;
  }

  .num4-lines {
    -webkit-line-clamp: 4;
  }

  .service {
    width: 200px;
    letter-spacing: 2px;
    font-size: 28px;
    font-weight: 600;
    padding: 10px 0;
    margin: 0 auto;
    text-align: center;
  }

  .service-box {
    box-sizing: border-box;

    .serviceItem {
      height: 380px;
      width: 1300px;
      margin: 0 auto;
      margin-top: 5px;
      box-sizing: border-box;
      border-radius: 16px;
      display: flex;
      flex-flow: row nowrap;
      justify-content: space-between;
      align-self: stretch;
      // box-shadow: 0 0 8px #99999947;
      border: 1px solid #efefef;

      .serviceItem-bg {
        width: 550px;
        background-size: 100% 100%;
        background-repeat: no-repeat;
        border-top-left-radius: 16px;
        border-bottom-left-radius: 16px;
      }

      .serviceItem-con {
        flex: 1;
        display: flex;
        flex-flow: column nowrap;
        justify-content: start;
        align-items: start;
        padding: 0 20px;

        .warp1 {
          .wrap1-title {
            color: #2d50a1;
            font-size: 22px;
            font-weight: 600;
          }
        }
      }
    }
  }
}

/deep/ .el-tabs__header {
  padding-bottom: 10px;
  position: relative;
  width: 1300px;
  margin: auto !important;
}

/deep/ .el-carousel__arrow--left {
  left: 250px;
}

/deep/ .el-carousel__arrow--right {
  right: 250px;
}

/deep/ .el-tabs__nav {
  // transform: translateX(-50%) !important;
  //   left: 50%;
  font-size: 24px;
  font-weight: bold;
}

/deep/ .el-tabs__item {
  font-size: 18px !important;
  font-weight: 500;
  padding: 0px;
  margin: 0 15px;
}

/deep/ .el-tabs__item:hover {
  color: #2d50a1;
  cursor: pointer;
}

/deep/ .el-tabs__item.is-active {
  color: #2d50a1;
  box-shadow: none !important;
  position: relative; /* 为伪元素定位做准备 */
  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%); /* 水平居中 */
    width: 100px;
    height: 3px;
    background-color: #2d50a1;
  }
}

/deep/ .el-tabs__active-bar {
  background-color: transparent;
}

/deep/ .el-carousel__container {
  height: 410px;
}

/deep/ .el-tabs__header::after {
  display: none !important;
}
</style>



// WEBPACK FOOTER //
// src/components/resourcePool/serviceProvider2.vue